(() => {
  if (customElements.get('platini-size-chart-drawer')) return;

  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const highlightProductNames = (root) => {
    if (!root) return;
    root.querySelectorAll('h2 + p, h3 + p').forEach((para) => {
      if (para.querySelector('.pltn-sc-named-product')) return;
      const raw = para.textContent.replace(/\u00a0/g, ' ').trim();
      if (!raw.includes('·') && !raw.includes('•')) return;

      const parts = raw.split(/\s*[·•]\s*/);
      if (parts.length < 2) return;

      para.textContent = '';
      parts.forEach((part, index) => {
        const label = part.trim();
        if (!label) return;
        if (index > 0) {
          const sep = document.createElement('span');
          sep.className = 'pltn-sc-name-sep';
          sep.textContent = ' · ';
          para.appendChild(sep);
        }
        if (/^and\b/i.test(label)) {
          para.appendChild(document.createTextNode(label));
        } else {
          const name = document.createElement('span');
          name.className = 'pltn-sc-named-product';
          name.textContent = label;
          para.appendChild(name);
        }
      });
    });
  };

  const markProductTitles = (root, productTitle) => {
    if (!root) return null;
    const productNorm = normalize(productTitle || root.dataset.productTitle);
    let current = null;

    root.querySelectorAll('h2, h3').forEach((heading) => {
      heading.classList.add('pltn-sc-product-title');
      const headingNorm = normalize(heading.textContent);
      if (!productNorm || !headingNorm) {
        heading.classList.remove('pltn-sc-product-title--current');
        return;
      }

      const match =
        productNorm === headingNorm ||
        productNorm.includes(headingNorm) ||
        headingNorm.includes(productNorm);

      heading.classList.toggle('pltn-sc-product-title--current', match);
      if (match && !current) current = heading;
    });

    highlightProductNames(root);
    return current;
  };

  class PlatiniSizeChartDrawer extends HTMLElement {
    connectedCallback() {
      this.openBtn = this.querySelector('[data-pltn-sc-open]');
      this.closeEls = this.querySelectorAll('[data-pltn-sc-close]');
      this.panel = this.querySelector('.pltn-sc-drawer__panel');
      this.overlay = this.querySelector('.pltn-sc-drawer__overlay');
      this.content = this.querySelector('.pltn-sc-drawer__content');
      this._onKey = this._onKey.bind(this);

      this.openBtn?.addEventListener('click', () => this.open());
      this.closeEls.forEach((el) => el.addEventListener('click', () => this.close()));
      this.wrapTables(this);
      this.currentTitle = markProductTitles(
        this.querySelector('.pltn-pdp-size-chart__body'),
        this.dataset.productTitle
      );

      document.querySelectorAll('.accordion__content .pltn-pdp-size-chart__body').forEach((body) => {
        this.wrapTables(body);
        markProductTitles(body, body.dataset.productTitle || this.dataset.productTitle);
      });
    }

    wrapTables(root) {
      if (!root) return;
      root.querySelectorAll('table').forEach((table) => {
        if (table.parentElement?.classList.contains('pltn-pdp-size-chart__table-wrap')) return;
        const wrap = document.createElement('div');
        wrap.className = 'pltn-pdp-size-chart__table-wrap';
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);
      });
    }

    open() {
      this.classList.add('is-open');
      this.panel?.removeAttribute('hidden');
      this.overlay?.removeAttribute('hidden');
      this.openBtn?.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKey);
      this.querySelector('[data-pltn-sc-close]')?.focus();

      if (this.currentTitle) {
        requestAnimationFrame(() => {
          this.currentTitle.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
      }
    }

    close() {
      this.classList.remove('is-open');
      this.panel?.setAttribute('hidden', '');
      this.overlay?.setAttribute('hidden', '');
      this.openBtn?.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this._onKey);
      this.openBtn?.focus();
    }

    _onKey(event) {
      if (event.key === 'Escape') this.close();
    }
  }

  customElements.define('platini-size-chart-drawer', PlatiniSizeChartDrawer);
})();
